module.exports = __webpack_public_path__ + "media/images/font/Gustavo-BoldItalic-5ea52e7d92fcfe3b37a07393e26ef1c0.svg";